export class AWSSettings {
    access_key_id:string;
    secret_access_key:string;
    bucket:string;
    region:string;
    constructor(jsonData?:any) {
        if (!(jsonData)) return; //allow construction of empty instance
        this.access_key_id = jsonData.access_key_id;
        this.secret_access_key = jsonData.secret_access_key;
        this.bucket = jsonData.bucket;
        this.region = jsonData.region;
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/application/aws_settings.model.ts